import { createAction, props } from '@ngrx/store'
import { Education } from './education.state'

// Action to load Department
export const loadEducations = createAction(
  '[Education] Load Education',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Education load
export const loadEducationsSuccess = createAction(
  '[Education] Load Education Success',
  props<{
    educations: Education[]
  }>()
)

// Action for Department load failure
export const loadEducationsFailure = createAction(
  '[Education] Load Education Failure',
  props<{ error: string }>()
)

export const createEducation = createAction(
  '[Education] Create Education',
  props<{
    payload: any
  }>()
)

export const createEducationSuccess = createAction(
  '[Education] Create Education Success',
  props<{ education: Education }>()
)

export const createEducationFailure = createAction(
  '[Education] Create Education Failure',
  props<{ error: any }>()
)

export const updateEducation = createAction(
  '[Education] Update Education',
  props<{ id: string; payload: any }>()
)

export const updateEducationSuccess = createAction(
  '[Education] Update Education Success',
  props<{ education: Education }>()
)

export const updateEducationFailure = createAction(
  '[Education] Update Education Failure',
  props<{ error: any }>()
)

export const deleteEducation = createAction('[Education] Delete Education', props<{ id: string }>())

export const deleteEducationSuccess = createAction(
  '[Education] Delete Education Success',
  props<{ id: string }>()
)

export const deleteEducationFailure = createAction(
  '[Education] Delete Education Failure',
  props<{ error: any }>()
)
